import { Col, Row } from "antd";
import "moment/locale/ar";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllSponsorRequests,
  getRequestsTypes,
} from "../../../../apis/actions/sponsor.actions";
import { AppDispatch, RootState } from "../../../../apis/store";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
import ModalComponent from "../../../../biblio/Modal/ModalComponent";
import AddSponsorRequest from "./AddSponsorRequest";
import "moment/locale/ar";
import CustomConfigProvider from "../../ProfileHeader";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
import Selects from "../../../../biblio/Selects/Selects";
import { scroll, toFilterData } from "../../../../components/utils/utils";
import SponsorRequests from "./SponsorRequests";
const SponsorRequestsOverview = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);

  const { requestsTypes, requests, loading } = useSelector(
    (state: RootState) => state?.sponsor
  );
  const OtpId =  useSelector(
    (state: RootState) => state?.recipient?.OtpId
  );
  useEffect(() => {
    dispatch(getRequestsTypes());
    dispatch(getAllSponsorRequests({ sponsor_id : OtpId }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  const [selectedFilter, setSelectedFilter] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [state, setState] = useState({
    year: "",
    month: "",
  });
  const [filteredRequests, setFiltredRequests] = useState<any[]>([]);
  useEffect(() => {
    let list = selectedFilter
      ? requests?.filter(
          (request: any) => request.request_type_id === selectedFilter
        )
      : requests;

    setCurrentPage(1);
    setFiltredRequests(toFilterData(list, state));
  }, [requests, selectedFilter, state]);
  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  const itemPerPage = 4;

  const handleSelectChange = (value: any) => {
    if (value) {
      setSelectedFilter(value.label);
    } else {
      setSelectedFilter(null);
    }
    setCurrentPage(1);
  };

  return (
    <>
      <CustomConfigProvider
        withdateFilter={true}
        filterState={state}
        setState={(values) => setState(values)}
        title="تواصل معنا"
      >
        <Selects
          options={requestsTypes}
          selectPlaceholder="نوع الطلب"
          onChange={handleSelectChange}
          allowClear={true}
          className="takaful--service-select"
          popupClassName="takaful--service-select-dropdown"
        />
      </CustomConfigProvider>
      <Row>
        <Col xxl={4} xl={4} lg={4} md={4} sm={24} xs={24}>
          <PrimaryButton
            onClick={() => setIsModalVisible(true)}
            title=" إنشاء طلب "
            className="takaful--add-request-btn"
          />
        </Col>
      </Row>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : requests?.length === 0 ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا توجد طلبات
        </p>
      ) : filteredRequests?.length === 0 ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد طلبات تتوافق مع البحث الذي قمت به
        </p>
      ) : (
        <>
          <Row gutter={[16, 48]} justify={"space-around"} ref={currentRef}>
            <SponsorRequests
              requests={filteredRequests.slice(
                (currentPage - 1) * itemPerPage,
                (currentPage - 1) * itemPerPage + itemPerPage
              )}
            />
          </Row>
          <div className="takaful--pagination-container">
            {filteredRequests && filteredRequests?.length > itemPerPage && (
              <PaginationComponent
                active={currentPage}
                total={filteredRequests?.length}
                itemPerPage={itemPerPage}
                scroll={() => scroll(currentRef)}
                setActive={(nb) => updateActive(nb)}
              />
            )}
          </div>
        </>
      )}
      <ModalComponent
        title=""
        open={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        closeOnOutsideClick={true}
        width={800}
        modalStyle={{ top: 200 }}
      >
        <AddSponsorRequest
          setIsModalVisible={setIsModalVisible}
          requestsTypes={requestsTypes}
        />
      </ModalComponent>
    </>
  );
};

export default SponsorRequestsOverview;
